/* unplugin-vue-components disabled */import { render } from "./BasicDialog.vue?vue&type=template&id=7d8c2731"
import script from "./BasicDialog.vue?vue&type=script&lang=js"
export * from "./BasicDialog.vue?vue&type=script&lang=js"

import "./BasicDialog.vue?vue&type=style&index=0&id=7d8c2731&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__